import { createTheme } from "@mui/material/styles";

// Create a theme instance.
const theme = createTheme({
  typography: {
    fontFamily: "ABCDiatypeRegular",
  },
  palette: {
    primary: {
      main: "#98A481",
      dark: "#98A481",
      light: "#CCFFFF",
    },
    secondary: {
      main: "#BBDFE8",
      dark: "#BBDDE6",
      light: "#e3f2fd",
    },
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          // color: '#fff',
          fontFamily: "SackersGothic",
          // background: '#98A481',
        },
        contained: {
          color: "#fff",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        // Name of the slot
        root: {
          color: "#98A481",
          borderColor: "#98A481",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#3D4732",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        // Name of the slot
        root: {
          color: "#333333",
          borderColor: "#98A481",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Raleway';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Raleway'), local('Raleway-Regular'), url(${process.env.APP_URL}/fonts/ABCDiatype-Regular.otf) format('otf');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

export default theme;
